/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const ROUTES = {
  ALBUM_DETAILS_SCREEN: "/album-details",
  ARTICLE_SCREEN: "/article-details",
  AUTH_CONFIRM_EMAIL: "/auth/confirmAccount",
  AUTH_RESET_PASSWORD: "/auth/resetPassword",
  BASE: "/",
  BUY_CONFIRMATION_SCREEN: "/buy-confirmation",
  BUY_SCREEN: "/buy",
  CATEGORY_DETAILS_SCREEN: "/category-details",
  CATEGORY_SCREEN: "/category",
  CLUB_DETAILS_SCREEN: "/club",
  COINS_PAYMENT_SUCCESS: "/coins-payment-success",
  COINS_PAYMENT: "/coins-payment",
  CONSENT_SCREEN: "/consent",
  DELETE_ACCOUNT_SUCCESS: "/delete-account-success",
  DELETE_ACCOUNT: "/delete-account",
  EPG_SCREEN: "/epg",
  EVENT_DETAILS_SCREEN: "/event",
  EVENTS: "/events",
  FAQ: "/faq",
  FORGOT_PASSWORD_SUCCESS: "/forgot-password-success",
  FORGOT_PASSWORD: "/forgot-password",
  HOME: "/home",
  INDEX: "/index.html",
  LANGUAGE_SCREEN: "/language",
  LEAGUE_DETAILS_SCREEN: "/league",
  LINK_SCREEN: "/link",
  LIVE_DETAILS_SCREEN: "/live-details",
  LOGIN_VIA_EMAIL: "/emailLogin",
  LOGIN: "/login",
  MAIN_SCREEN: "/",
  MAINTENANCE_SCREEN: "/maintenance",
  MATCH_DETAILS_SCREEN: "/match",
  MEDIA_CREATOR: "/media-creator",
  MOVIE_DETAILS_SCREEN: "/movie-details",
  MYLIST_SCREEN: "/my-list",
  OFFERS_SCREEN: "/offers",
  PACKAGE_DETAILS_SCREEN: "/package-details",
  PAYMENT_CHANGE_STATUS_SCREEN: "/payment-change-status",
  PAYMENT_STATUS_SCREEN: "/payment-status",
  PERSON_DETAILS_SCREEN: "/person",
  PLAYER_SCREEN: "/player",
  PLAYLIST_SCREEN: "/playlist",
  PODCAST_DETAILS_SCREEN: "/podcast-details",
  PRIVACY_POLICY_SCREEN: "/privacy-policy",
  READ_MORE_SCREEN: "/read-more",
  REGISTER_CONFIRM_ACCOUNT_WITH_PASSWORD: "/confirmAccountWithPassword",
  REGISTER_CONFIRM: "/confirmEmail",
  REGISTER_SOCIAL: "/register-social",
  REGISTER_SUCCESS: "/register-success",
  REGISTER: "/register",
  RESET_PASSWORD: "/resetPassword",
  SEARCH_SCREEN: "/search",
  SEASON_DETAILS_SCREEN: "/season-details",
  SERIES_DETAILS_SCREEN: "/series-details",
  SETTINGS_ABOUT_SCREEN: "/settings/about",
  SETTINGS_HELP_SCREEN: "/settings/help",
  SETTINGS_MY_CONSENTS_SCREEN: "/settings/my-consents",
  SETTINGS_MY_ORDERS: "/settings/my-orders",
  SETTINGS_PRIVACY_POLICY_SCREEN: "/settings/privacy-policy",
  SETTINGS_PROFILE: "/settings/profile",
  SETTINGS_REGULATIONS_SCREEN: "/settings/regulations",
  SETTINGS_SCREEN: "/settings",
  TEAM_DETAILS_SCREEN: "/team",
  VOUCHER_PAYMENT_STATUS: "/voucher-payment-status",
  VOUCHER_PAYMENT: "/voucher-payment",
};
